// BloomHer official brand logo (from bloomher.health).
const HEIGHTS = {
  "text-xl": "h-7",
  "text-2xl": "h-8",
  "text-3xl": "h-10",
  "text-4xl": "h-12",
};

export const BloomHerLogo = ({ size = "text-3xl", className = "", footer = false }) => (
  <img
    src={footer ? "/logo-footer.webp" : "/logo.webp"}
    alt="BloomHer"
    className={`${HEIGHTS[size] || "h-10"} w-auto object-contain ${className}`}
  />
);

export default BloomHerLogo;
